var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#6576FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0794 8.8162H10.132V4.86883C10.132 4.69435 10.0627 4.52701 9.9393 4.40363C9.81592 4.28025 9.64858 4.21094 9.4741 4.21094C9.29961 4.21094 9.13227 4.28025 9.00889 4.40363C8.88551 4.52701 8.8162 4.69435 8.8162 4.86883V8.8162H4.86883C4.69435 8.8162 4.52701 8.88551 4.40363 9.00889C4.28025 9.13227 4.21094 9.29961 4.21094 9.4741C4.21094 9.64858 4.28025 9.81592 4.40363 9.9393C4.52701 10.0627 4.69435 10.132 4.86883 10.132H8.8162V14.0794C8.8162 14.2538 8.88551 14.4212 9.00889 14.5446C9.13227 14.6679 9.29961 14.7373 9.4741 14.7373C9.64858 14.7373 9.81592 14.6679 9.9393 14.5446C10.0627 14.4212 10.132 14.2538 10.132 14.0794V10.132H14.0794C14.2538 10.132 14.4212 10.0627 14.5446 9.9393C14.6679 9.81592 14.7373 9.64858 14.7373 9.4741C14.7373 9.29961 14.6679 9.13227 14.5446 9.00889C14.4212 8.88551 14.2538 8.8162 14.0794 8.8162Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallPlus);
export default __webpack_public_path__ + "static/media/SmallPlus.c0acbce5.svg";
export { ForwardRef as ReactComponent };